import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { globalModel } from "../../global/GlobalModel";
import { standaloneProductRegistry } from "./StandaloneProductRegistry";
import { sitePageBackgroundStyle, productPageBackgroundCssVars } from "../../SiteConfig";
import { UserNotesEntitlementProvider } from "../../components/fin-web/UserNotesEntitlementContext";
import { ConceptEntitlementProvider } from "../../components/fin-web/ConceptEntitlementContext";
import { UserHoldingsEntitlementProvider } from "../../components/fin-web/UserHoldingsEntitlementContext";
import { TactikSiteTopBar } from "./TactikSiteTopBar";
import "./TactikAppShell.css";

export const TactikAppShell = observer(() => {
  useEffect(() => {
    void standaloneProductRegistry.ensureLoaded();
  }, []);

  useEffect(() => {
    if (!standaloneProductRegistry.isReady) {
      return;
    }
    void standaloneProductRegistry.reload();
  }, [globalModel.isLoggedIn]);

  const slots = standaloneProductRegistry.slotViews();

  return (
    <div
      className="tactik-app"
      style={{
        ...sitePageBackgroundStyle("standaloneShell"),
        ...productPageBackgroundCssVars(),
      }}
    >
      <TactikSiteTopBar />
      <main className="tactik-app-main">
        {standaloneProductRegistry.loadError ? (
          <p className="tactik-app-load-error" role="alert">
            {standaloneProductRegistry.loadError}
          </p>
        ) : null}
        <UserNotesEntitlementProvider membershipProducts={standaloneProductRegistry.catalogModules}>
          <ConceptEntitlementProvider membershipProducts={standaloneProductRegistry.catalogModules}>
            <UserHoldingsEntitlementProvider membershipProducts={standaloneProductRegistry.catalogModules}>
              <Outlet context={{ slots }} />
            </UserHoldingsEntitlementProvider>
          </ConceptEntitlementProvider>
        </UserNotesEntitlementProvider>
      </main>
    </div>
  );
});

/** 供子路由读取当前槽位视图 */
export type TactikOutletContext = {
  slots: ReturnType<typeof standaloneProductRegistry.slotViews>;
};
